import { render } from "./Eingabe.vue?vue&type=template&id=545c2b23"
import script from "./Eingabe.vue?vue&type=script&lang=js"
export * from "./Eingabe.vue?vue&type=script&lang=js"

import "./Eingabe.vue?vue&type=style&index=0&id=545c2b23&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__